export default __webpack_public_path__ + "static/media/threeDots.e6f90819.svg";